<script setup lang="ts">
import { RouterView } from 'vue-router'
import CelebrationOverlay from '@/components/learner/CelebrationOverlay.vue'
</script>

<template>
  <main class="app-shell">
    <RouterView />
    <!-- Sprint 1 §11.3: global celebration overlay; subscribes to the
         celebration Pinia store and renders when an attempt fires an event. -->
    <CelebrationOverlay />
  </main>
</template>

<style scoped>
.app-shell {
  min-height: 100vh;
  background: var(--color-background);
  color: var(--color-text-body);
}
</style>
